module.exports = __webpack_public_path__ + "img/file_table.72dd1d14.png";